import { connect } from 'react-redux'
import Routes from './Routes'

const mapStateToProps = (state, ownProps) => {
  return {
    userLanguauge: state.loginLayout.profile.userLanguauge,
    ...ownProps
  }
}

const RoutesContainer = connect(
  mapStateToProps
)(Routes)

export default RoutesContainer



// WEBPACK FOOTER //
// ./src/RoutesContainer.js